
const Shadow = (props) => {
    
    return (

        <div className={`fixed inset-0 bg-gray-900/50 z-30 ${props.className || ''}`} onClick={props.onClick} >
        </div>)
}

export default Shadow;